
import React from 'react';
import { Lead } from '@/types/lead';
import KeyContactsTabContent from '@/components/business/KeyContactsTabContent';

interface ContactsTabContentProps {
  lead: Lead;
  onContactsUpdated: () => void;
}

const ContactsTabContent: React.FC<ContactsTabContentProps> = ({ lead, onContactsUpdated }) => {
  return (
    <KeyContactsTabContent 
      leadId={lead.id} 
      contacts={lead.keyContacts || []} 
      onContactsUpdated={onContactsUpdated} 
    />
  );
};

export default ContactsTabContent;
